
class FunsiteResidueSet {
    constructor(id, color, label, residues) {
        this.id = id
        this.color = color
        this.label = label
        this.residues = residues
    }
}

export default FunsiteResidueSet;